import React from 'react'
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer'
import Nav from '../../components/Nav/Nav'
import CardStatusCard from '../../components/CardStatusCard/CardStatusCard';
import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';


//right carrots
//import u80 from '../../images/hsa-dashboard/u80.png'
//import u144 from '../../images/hsa-dashboard/u144.png'//mouseover


 


export default class AccountCards extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={
            //modal vars
            
        }
    } 
    
    

    renderCards=()=>{
        const cards=[
                        {status:true, name_on_card:"John Doe", card_num:'1234 1234 1234 1234', exp_date:'09/2025', cvv:123},
                        {status:true, name_on_card:"Jane Doe", card_num:'1234 1234 1234 2330', exp_date:'09/2025', cvv:123},
                        {status:false, name_on_card:"John Doe", card_num:'1234 1234 1234 1067', exp_date:'08/2025', cvv:123},
                        {status:false, name_on_card:"Jane Doe", card_num:'1234 1234 1234 2111', exp_date:'08/2025', cvv:123}
                    ]
        return(
            <div>
           { cards.map((item, index)=><div>
                                            {index!==0 && <div style={{display:"flex",flexDirection:'row',flex:1,height:1,marginRight:'1.1vw',marginLeft:'1.1vw', backgroundColor:Colors.grey}}></div>}
                                            <CardStatusCard key={index} status={item.status} name_on_card={item.name_on_card} card_num={item.card_num} exp_date={item.exp_date} cvv={item.cvv} />
                                      </div>)}
           </div>
        )
    }

    render(){
        return <div ref={this.parentRef} style={{display:'flex',height:"auto", width:'auto',flexDirection:'column', backgroundColor:Colors.light_grey,overflowX:'hidden'}}>
            <Header authed={true} navigator={this.props.navigator}/>
            <div style={{ display:'flex', flexDirection:'row', backgroundColor:Colors.light_grey}}>
                <div style={{ display:'flex',flex:1,justifyContent:'right',alignItems:'right'}}>
                    <Nav navigator={this.props.navigator} page='accountCards'/>
                </div>
                <div style={{ display:'flex',flexDirection:'column',flex:3, paddingTop:'2.4vh', paddingLeft:"1vw",paddingRight:'20vw'}}>
                    <div>{/**Title*/}
                        <span style={{...Fonts.title,color:"#003F97"}}><span style={{...Fonts.title,color:'#000'}}>Accounts / </span>Cards</span>
                    </div>
                    <div style={{background:"#FFF",width:"47vw",height:'120vh', border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:'2.3vh'}}>{/**white view */}
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center', marginTop:'2.8vh', marginLeft:'1vw'}}>{/**white view header */}
                                <span style={{...Fonts.subtitle, marginRight:'0.7vw'}}>My Card Status</span>
                        </div>
                        {this.renderCards()}
                    </div>
                    <div style={{display:'flex',height:'9vh', background:Colors.light_grey,}}></div>
                </div>
                
            </div>
            
            <Footer/>
        </div>
    }
}